// Helper function to calculate order amounts
export const calculateOrderAmounts = (items, shippingCost = 0) => {
  // Calculate subtotal
  let subtotal = 0;
  
  // Calculate subtotal from cart items
  items.forEach(item => {
    if (item.type === 'buy') {
      subtotal += item.price * item.quantity;
    } else if (item.type === 'rent') {
      // For rental items, use the rental price
      if (item.rentalPeriod && item.rentalPeriod.price) {
        subtotal += item.rentalPeriod.price * item.quantity;
      } else if (item.rentTimeSelect && item.rentTimeSelect.price) {
        subtotal += item.rentTimeSelect.price * item.quantity;
      } else if (item.rentPriceAndTime && item.rentPriceAndTime.length > 0 && item.rentPriceAndTime[0].price) {
        subtotal += item.rentPriceAndTime[0].price * item.quantity;
      } else {
        subtotal += item.price * item.quantity; // Fallback for rent if specific rental price missing
      }
    } else {
      // Handle other types like 'swap' or default to item.price
      subtotal += item.price * item.quantity;
    }
  });
  
  // Calculate platform fee, tax, and total with shipping
  const platformFee = subtotal * 0.1; // 10% platform fee
  const tax = (subtotal + platformFee) * 0.08; // 8% tax
  const totalAmount = subtotal + platformFee + tax + shippingCost;
  
  return { 
    subtotal, 
    platformFee, 
    tax, 
    shippingCost, 
    totalAmount 
  };
}; 